<script>
  export let name = '';
  /**
   * Specify the icon to render
   * @type {typeof import("carbon-icons-svelte/lib/Add16").default} [icon]
   */
  export let icon = undefined;
</script>

<div
  class:bx--header__user="{true}"
  {...$$restProps}
  on:click
>
  <span>
    {name}
  </span>
  <div class:bx--header__user-icon="{true}">
    <slot>
      <svelte:component this="{icon}" />
    </slot>
  </div>
</div>

<style>
  .bx--header__user {
    height: 3rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 600;
    color: white;
  }
  .bx--header__user-icon {
    height: 3rem;
    width: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>
